<!-- 小程序公共页 -->
<template>
  <div>
    <a-page-header class="vd-gl-header-warp">
      <template slot="footer">
        <a-tabs :default-active-key="this.$route.path" @change="changePane">
          <!--          <a-tab-pane v-show="$AuthUtil.authRoute('/program/detail/statistical')"-->
          <!--                      key="/program/detail/statistical"-->
          <!--                      tab="数据展示"/>-->
          <a-tab-pane
            v-if="this.$AuthUtil.authRoute('/program/detail/page')"
            key="/program/detail/page"
            tab="推广页面"
          />
          <a-tab-pane key="/program/detail/modify" tab="添加成员" />
          <a-tab-pane
            v-if="this.$AuthUtil.authRoute('/program/detail/member')"
            key="/program/detail/member"
            tab="推广成员"
          />
          <a-tab-pane
            v-if="this.$AuthUtil.authRoute('/program/detail/client')"
            key="/program/detail/client"
            tab="推广信息"
          />
          <!--          <a-tab-pane key="/program/detail/template" tab="模版消息"/>-->
          <!--          <a-tab-pane key="/program/detail/message" tab="订阅消息"/>-->
        </a-tabs>
      </template>
      <a-descriptions size="small" :column="1">
        <a-descriptions-item label="小程序id">
          {{ id }}
        </a-descriptions-item>
        <a-descriptions-item label="小程序名称">
          {{ detail.name }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">
          {{ detail.add_time }}
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          {{ detail.description }}
        </a-descriptions-item>
      </a-descriptions>
      <div class="vd-gl-statistic-group">
        <!-- 小程序状态 -->
        <a-statistic
          title="小程序状态"
          :value="detail.status === 1 ? '推广中' : '推广结束'"
          class="vd-gl-statistic"
        />
        <!-- 推广员数量 -->
        <a-statistic title="推广员" :value="num" class="vd-gl-statistic">
          <template slot="prefix">
            <a-icon type="user" />
          </template>
        </a-statistic>
        <!-- 推广总量 -->
        <a-statistic title="推广量" :value="count" class="vd-gl-statistic" />
      </div>
    </a-page-header>
    <router-view />
  </div>
</template>

<script>
import { get_detail } from '@/api/program'

export default {
  name: 'ActivityDetail',
  data() {
    return {
      // data
      id: null,
      detail: {
        activity_time: 0,
        add_time: 1600045345,
        sid: '-',
        description: '-',
        name: '-',
        status: 1,
        upd_time: 1600050274,
      },
      num: 0,
      count: 0,
    }
  },
  created() {
    /* 获取参数*/
    this.id = this.$route.query.id
    if (!this.id) {
      this.$message.error({ content: '访问参数错误' })
      // 链接回跳
      this.$router.push({ path: '/program/setting', replace: true })
      return false
    }
    this.getDetail()
  },
  methods: {
    getDetail() {
      // 获取此id下的详细信息
      get_detail({ activeId: this.id }).then((res) => {
        if (res.code === 1) {
          this.num = res.num
          this.count = res.count
          this.detail = res.data
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 跳转
    changePane(value) {
      // 判断参数是否正确
      if (this.id) {
        this.$router.replace({ path: value, query: { id: this.id } })
      } else {
        this.$message.error({ content: '访问参数错误' })
        // 链接回跳
        this.$router.replace({ path: '/program/setting', replace: true })
        return false
      }
    },
  },
}
</script>

<style scoped></style>
